import { useEffect } from 'react';

export function ConfirmDialog({
    open,
    title,
    body,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    confirmTone = 'danger', // 'danger' or 'primary'
    onConfirm,
    onCancel,
}) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onCancel]);

    if (!open) return null;

    const handleBackdrop = (e) => { if (e.target === e.currentTarget) onCancel(); };

    return (
        <div
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0,0,0,0.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
                zIndex: 50,
            }}
            onClick={handleBackdrop}
        >
            <div
                role="dialog"
                aria-modal="true"
                className="surface-card"
                style={{ padding: 22, width: '100%', maxWidth: 440 }}
            >
                <h2 style={{ fontSize: 15, fontWeight: 500, marginBottom: 6 }}>{title}</h2>
                <p style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 18, lineHeight: 1.55 }}>
                    {body}
                </p>
                <div className="flex justify-end" style={{ gap: 8 }}>
                    <button type="button" onClick={onCancel} className="btn btn-ghost">
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className={`btn ${confirmTone === 'primary' ? 'btn-primary' : 'btn-danger'}`}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
